/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { DigitizePointService } from '@map/command/digitize-point/digitize-point.service';
import { DigitizePointReportComponent } from './digitize-point-report.component';

@NgModule({
    imports: [ DigitizePointReportComponent ],
    providers: [ DigitizePointService ]
})
export class DigitizePointReportModule {
    constructor(private injector: Injector) {
        const el = createCustomElement(DigitizePointReportComponent, {
            injector: this.injector
        });
        customElements.define('dash-gis-digitize-point-report', el);
    }
}
